// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__Dj1ba","modal__report-container":"styles_modal__report-container__wjPp2","modal__report__grouping":"styles_modal__report__grouping__HeICk"};